import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=17864afb"
import script from "./SuperTable.vue?vue&type=script&lang=js"
export * from "./SuperTable.vue?vue&type=script&lang=js"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=17864afb&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports